export default {
    downtimeUrl: "https://cl.kodland.tech",
    startPage: {
      image: "/welcome/quiz_turkey_coding_girl_pk.jpg",
      imageMobile: "/welcome/quiz_turkey_coding_girl_mobile.jpg",
      title: "Çocuğunuzun ilgi alanlarını keşfetmek için harika bir fırsat!",
      subtitle:
        "Şimdi kayıt olun ve çocuğunuz için sınırlı sayıdaki Ücretsiz Python dersini alın! ",
      button: "Ders alın 🚀",
    },
      stopPage: {
      image: "/quiz_stop_page.jpg",
      title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
    },
    quizRotateBySteps: {
      1: {
        question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
        answers: [
          {
            answer: "💻 Evet",
            distribution_tag_question: [18],
          },
          {
            answer: "😐 Hayır",
            stopAnswer: true
          },
        ],
      },
      2: {
        title: "Deneme dersi için hangi saatte uygunsunuz?",
        type: "timeslot",
        subtitle:
          "Özel dersinizi rezerve etmek için birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳 Ücretsiz kurs üç ücretsiz dersten oluşmaktadır. Aşağıdan mevcut bir ders aralığı seçerek her gün bir ders olmak üzere önümüzdeki üç gün için ders rezervasyonu yapabilirsiniz.",
        button: "Rezervasyon için tıklayın 🎁",
      },
      3: {
        title: "Çocuğunuz kaç yaşında?",
        type: "age",
        subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz. Lütfen çocuğunuzun doldurduğu yaşı seçin.",
        button: "İleri 🚀",
      },
      4: {
        title: "Çocuğunuzun adı nedir?",
        type: "child_name",
        subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir 🚨",
        button: "İleri 🚀",
      },
      5: {
        title: "E-postanızı girin",
        type: "mail",
        subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
        button: "İleri 🚀",
      },
      6: {
        title: "Telefon numaranızı girin",
        type: "phone",
        subtitle: "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
        button: "Neredeyse bitti 🔥",
      },
      7: {
        title: "İsminizi girin",
        type: "parent_name",
        subtitle: "Bizim adımız Kodland, sizinki ne?👋",
        button: "Son adım! 🎉",
      },
    },
  };
  